import { TextField, FormHelperText, Button } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import QuestionAddOrUpdate from "./QuestionAddOrUpdate";
import { AddWorkoutApi } from "src/DAL/workout/workout";

const AddWorkBook = ({}) => {
  const { state } = useLocation();
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);
  const [file, setImage] = useState();
  const [imageStatus, setImageStatus] = useState(false);
  const [questionsToSend, setQuestionsToSend] = useState([]);
  const [editShow, setEditShow] = useState([]);

  const [inputs, setInputs] = useState({
    video_url: "",
    image: "",
    workout_note: "",
  });

  const navigate = useNavigate();

  const fileChangedHandler = (e) => {
    setImageStatus(true);
    setImage(URL.createObjectURL(e.target.files[0]));
    setInputs({
      ...inputs,
      ["image"]: e.target.files[0],
    });
  };

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const urlPatternValidation = (URL) => {
    const regex = new RegExp(
      "(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?"
    );
    return regex.test(URL);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isLoading) {
      return;
    }
    setIsLoading(true);
    if (
      urlPatternValidation(inputs.video_url) === false &&
      inputs.video_url != ""
    ) {
      enqueueSnackbar("Enter Valid Video URL", { variant: "error" });
      setIsLoading(false);
      return;
    }
    if (inputs.video_url == "" && inputs.image != "") {
      enqueueSnackbar("Please Enter Video URL ", {
        variant: "error",
      });
      setIsLoading(false);
      return;
    }

    if (inputs.video_url && inputs.image == "") {
      enqueueSnackbar("Please Upload Video Thumbnail", { variant: "error" });
      setIsLoading(false);
      return;
    }
    setIsLoading(true);
    let isError = false;
    let exerciesArray = [];
    if (isError) {
      setIsLoading(false);
      return;
    }
    const formData = new FormData();
    formData.append("title", state?.title);
    formData.append("image", state?.image);
    formData.append("practice_type", "workbook");

    if (imageStatus) {
      formData.append("video_thumbnail", inputs.image);
    }

    formData.append("video_url", inputs.video_url);
    formData.append("library_type", state?.type);
    formData.append("description", state?.short_description);
    formData.append("status", state?.status);
    formData.append("questions", JSON.stringify(questionsToSend));
    formData.append(
      "difficulty_levels",
      JSON.stringify(state?.difficulty_levels)
    );
    formData.append("exercises", JSON.stringify(exerciesArray));
    formData.append("workout_note", "");
    console.log(exerciesArray, "dskjfhakjdsh");
    console.log(...formData, "dskjfhakjdsh");

    const result = await AddWorkoutApi(formData);
    if (result.code == 200) {
      enqueueSnackbar(result.message, { variant: "success" });
      navigate(-1);
      setIsLoading(false);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsLoading(false);
    }
  };

  return (
    <div className="container">
      <div className="row mt-3 align-items-center">
        <div className="col-12 col-md-10">
          <div className="d-flex align-items-center">
            <IconButton
              className="back-screen-button mb-0"
              onClick={() => navigate(-1)}
            >
              <ArrowBackIcon />
            </IconButton>
            <h1 className="programmes-heading ms-2">{state?.title}</h1>
          </div>
        </div>
        <div className="col-12 section-space">
          <div
            dangerouslySetInnerHTML={{
              __html: state?.short_description,
            }}
          ></div>
        </div>
        <div className="row my-3">
          <div className="col-11 video-text">
            <p>
              The video URL and the thumbnail image are linked, as adding a
              video URL requires a thumbnail and vice versa. The thumbnail will
              appear on the calendar, and clicking it will open the popup.
            </p>
          </div>
          <div className="col-lg-5 col-md-5 col-sm-12 ">
            <TextField
              id="outlined-basic"
              label="Video Url"
              variant="outlined"
              fullWidth
              name="video_url"
              value={inputs.video_url}
              onChange={handleChange}
            />
          </div>
          <div className="col-lg-7 col-md-7 col-sm-12">
            <div className="row w-100 div-style ms-0 p-0">
              <div className="col-lg-5 col-md-5 col-sm-12">
                <p className="mb-0">Upload Video Thumbnail </p>
                <FormHelperText className="pt-0" sx={{ fontSize: 9 }}>
                  Image Size(1280 X 720, 16:9 – fits the member app cards) ("JPG", "JPEG", "PNG","WEBP")
                </FormHelperText>
              </div>
              <div className=" col-lg-2 col-md-2 col-sm-12">
                {file ? (
                  <img className="image-border" src={file} height="50" />
                ) : (
                  ""
                )}
              </div>
              <div className="col-lg-5 col-md-5 col-sm-12  text-lg-end text-md-end text-sm-start pt-2">
                <label htmlFor="contained-button-file">
                  <input
                    accept=".jpg, .jpeg, .png, .webp"
                    id="contained-button-file"
                    multiple
                    type="file"
                    name="image"
                    required
                    onChange={fileChangedHandler}
                    style={{ display: "none" }}
                  />

                  <Button
                    className="small-contained-button"
                    startIcon={<FileUploadIcon />}
                    component="span"
                    variant="contained"
                    size="small"
                  >
                    Upload
                  </Button>
                </label>
              </div>
            </div>
            {inputs.image.name == "" ? (
              ""
            ) : (
              <p className="text-secondary">{inputs.image.name}</p>
            )}
          </div>
          <QuestionAddOrUpdate
            questionsToSend={questionsToSend}
            setQuestionsToSend={setQuestionsToSend}
            editShow={editShow}
            setEditShow={setEditShow}
          />
          {questionsToSend && questionsToSend.length > 0 && (
            <div className="text-end">
              <button
                className="small-contained-button"
                onClick={(e) => handleSubmit(e)}
              >
                {isLoading ? "Submitting..." : "Submit"}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default AddWorkBook;
